<template>
  <div>
    <section class="siteEnquire section">
      <div class="container">
        <h3 class="text-center">Seek Professional Help For Your Shoulder Pain Today</h3>
        <div class="row d-flex align-items-center">
          <div class="col-12 col-md-6 d-flex flex-column enquire-text">
            <ul>
              <li>Regain your pain-free activities</li>
              <li>Get back to an active lifestyle</li>
              <li>Effective, lasting methods available</li>
              <li>Committed to a smooth recovery</li>
            </ul>
            <img class="rounded img-fluid" src="/images/img-enquire.jpg" at="Heart Screening"/>
          </div>
          <div id="schedule-appt" class="col-12 col-md-6">
            <div id="enquire-now" class="enquiry-form">
              <p>Simply use the form below to reach us, we will get back within 24 hours.</p>
             <form  @submit.prevent="submit">

                      <div class="position-relative mb-4">
                        <input type="text" id="name" v-model="fields.name" class="form-control px-2 pt-4 pb-2 border" :class="errors && errors.name ? 'border-warning' : 'border-white'" />
                        <label class="form-label" for="name" :class="errors && errors.name ? 'text-danger' : 'text-black'">Name</label>
                        <InputError :field="errors.name" class="error-text"/>
                      </div>

                      <div class="position-relative mb-4">
                        <input type="text" id="contact" v-model="fields.contact" class="form-control px-2 pt-4 pb-2 border" :class="errors && errors.contact ? 'border-warning' : 'border-white'" />
                        <label class="form-label" for="contact" :class="errors && errors.contact ? 'text-danger' : 'text-black'">Contact Number</label>
                        <InputError :field="errors.contact" class="error-text"/>
                      </div>

                      <div class="position-relative mb-4">
                        <input type="email" id="email" v-model="fields.email" class="form-control px-2 pt-4 pb-2 border" :class="errors && errors.email ? 'border-warning' : 'border-white'" />
                        <label class="form-label" for="email" :class="errors && errors.email ? 'text-danger' : 'text-black'">Email</label>
                        <InputError :field="errors.email" class="error-text"/>
                      </div>

                       <div class="position-relative mb-4">
                        <textarea class="form-control px-2 pt-4 pb-2 border" v-model="fields.message" id="message" rows="7" :class="errors && errors.message ? 'border-warning' : 'border-white'" ></textarea>
                        <label class="form-label" for="message" :class="errors && errors.message ? 'text-danger' : 'text-black'">Message</label>
                        <InputError :field="errors.message" class="error-text"/>
                      </div>

                      <div class="w-full py-3">
                          <button type="submit" class="btn submit-btn rounded">
                                  <span>Submit</span>
                          </button>
                      </div>

                  </form>
              </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.form-control {
  height: 58px;
}

.submit-btn {
    font-family: Roboto;
    background-color: #ffffff;
    border-color: #ffffff;
    color: #000000;
    text-transform: uppercase;
    font-size: 15px;
    width: 150px;
    font-weight: bold;
    font-style: normal;
    line-height: 2em;
    padding: 0 20px; 
    border-width: 1px;
    border-style: solid;
    border-radius: 0px;
    min-height: calc( 10px + 2em + 16px );
}

textarea.form-control {
  height: 150px;
}

.form-label {
  position: absolute;
  top: 5px;
  font-size: 13px;
  left: 7px;
}

.error-text {
  position: absolute;
  bottom: -40px;
  left: 7px;
  font-size: 12px;
  font-weight: normal!important;
  color: red!important;
}
    
  .siteEnquire {
    background: #f5f5f5;
  }
  .enquiry-form {
    text-align: center;
    background: #000000;
    padding: 30px 15px;
  }
  .enquiry-form p {
    font-weight: 700;
    color: white;
  }
  .enquire-text p {
    margin-bottom: 1.5rem;
  }
  iframe {
    min-height: 480px !important;
  }
  @media (min-width: 480px) {
    iframe {
      min-height: 430px !important;
    }
  }
  @media (min-width: 768px) {
    iframe {
      min-height: 490px !important;
    }
  }
  @media (min-width: 992px) {
    .enquiry-form {
      padding: 50px 30px;
    }
    iframe {
      min-height: 480px !important;
    }
  }
  @media (min-width: 1200px) {
    iframe {
      min-height: 430px !important;
    }
  }
</style>

<script>
import { InputError, hapiMixins } from '@juno0424/vue2-hapi-inputs'

export default {
    mixins: [hapiMixins],
    components: { InputError},
    data() {
        return {
            endpoint: "https://hapiform.sg/api/3efc7e49-f1bd-4caa-8c03-e27873483cd1",
            redirectTo: "/thank-you"
        }
    }
}
</script>